import React from 'react'
import './artwork.css'

//images
import art1 from '../../images/art-1.svg'
import art2 from '../../images/art-2.svg'
import art3 from '../../images/art-3.svg'
import art4 from '../../images/art-4.svg'

import BB from '../../images/shangu_updated/BB.jpg';
import BB1 from '../../images/shangu_updated/BB(1).jpg';
import BB2 from '../../images/shangu_updated/BB(2).jpg'
import BB3 from '../../images/shangu_updated/BB(3).jpg';


const Artwork = () => {
    return (
        <div className='artwork' id='artwork'>
            <div className='heading'>
                <div>
                    <h2>
                        The <span>Artwork</span>
                    </h2>
                    <div className='artwork-background'>
                        <div>
                        The Legends of Shangu are composed of 7,777 individual 1 of 1  NFT’s randomly generated from 277 traits, hand drawn by world renowned cartoon artist David Huynh.
                            <br />
                            <br />
                            There are 12 different Animals to collect and perks
                            for holders who collect complete sets.
                            <br />
                            <br />
                            The Legends of Shangu originated from the ancient
                            tale of the Jade Emperor who sent an immortal being
                            to Earth to build an army of beasts to protect the
                            heavenly gate from Nian, the Lord of the underworld,
                            whose goal is to unleash evil on the world with his
                            Army of Mutants. <br />
                            <br />
                            The Jade Emperor created a challenge to discover
                            which of Earth's beings would have the skills to
                            protect the world and just like this, the Legends
                            were born. Each animal was given 1 of 4 legendary
                            powers to complete their mission and was given the
                            responsibility of finding the ancient artifacts
                            needed which allowed them to send Nian back to the
                            underworld and after an epic battle, peace was
                            restored…
                            <br />
                            <br />
                            4000 years later in 2022, the uncertainty of the
                            world has created a gateway to the underworld…
                            <br />
                            <br />
                            Nian has been gathering the strength needed to
                            resurrect his army back to earth.
                            <br />
                            <br />
                            The awakening is coming…
                        </div>
                    </div>
                </div>
                <div className='artwork-images'>
                    <div className='top-artwork-images'>
                        <img src={BB} alt='artwork 1' />
                        <img src={BB1} alt='artwork 2' />
                    </div>
                    <div className='bottom-artwork-images'>
                        <img src={BB2} alt='artwork 3' />
                        <img
                            src={BB3}
                            alt='artwork 4'
                            className='last-artwork'
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Artwork
